import {
  COMMON_QUERY_CONFIG,
  COMMON_QUERY_RULES_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  COMMON_VIDEO_QUERY_RULES_CONFIG,
  ruleNewsPlus
} from './shared/configs';

enum SECTION_ENUM {
  LAW = 'Law',
  CLIMATE = 'Climate & Environment',
  EDUCATION = 'Education',
  DEFAULT = 'Default',
  RELATED_OPINION = 'Related Opinion',
  VIDEO = 'Video'
}

const MAIN = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? []), ruleNewsPlus],
    or: [
      { terms: { key: 'DJEThing', value: ['us-news'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['us-news/education'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['us-news/law'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['us-news/climate-environment'] } }
    ]
  }
};

const LAW = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['us-news/law'] } }]
  }
};

const CLIMATE = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['us-news/climate-environment'] } }]
  }
};

const EDUCATION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['us-news/education'] } }]
  }
};

const RELATED_OPINION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_RELATED_OPINION_QUERY_RULES_CONFIG.and ?? []),
      {
        codes_with_significance: {
          key: 'djething',
          significance: ['significant'],
          value: ['us-news', 'us-news/education', 'us-news/law', 'us-news/climate-environment']
        }
      }
    ],
    or: [],
    not: []
  }
};

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'DJEThing', value: 'us-news' } }, { prefix: { key: 'DJEThing', value: 'us-news/' } }],
    not: []
  }
};

export { MAIN, SECTION_ENUM, LAW, CLIMATE, EDUCATION, RELATED_OPINION, VIDEO };
